import { useCallback, useEffect, useRef, useState } from 'react';
import { IconClose, IconMenu } from '../../Icons';
import styles from './MobileMenu.module.css';
import { LeftLinks } from './LeftLinks.jsx';
import { DropdownCity } from './DropdownCity.jsx';
import { WelcomeLinks } from './WelcomeLinks.jsx';

export const NavDivMobileBypassHandleCloseMenu = 'NavDivMobileBypassHandleCloseMenu';
export const MobileMenu = ({
    ContainerNavRef,
    isAuthenticated,
    userId,
    AppDownloadModalRef
}) => {
    const [state, setState] = useState(false);
    useEffect(() => {
        if (!state) {
            setState(true)
        }
    }, [state])

    const [listerners, setListerners] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const MobileMenuRef = useRef();
    const refBarTitle = useRef()

    const fixMenuPosition = () => {
        const menu = MobileMenuRef.current;
        if (!menu) { return }
        const rect = ContainerNavRef.current.getBoundingClientRect();
        menu.style.top = `${rect.bottom}px`;
    }
    useEffect(() => {

        const startListeners = () => {
            if (listerners) { return }
            setListerners(true);
            window.addEventListener('scroll', fixMenuPosition);
            window.addEventListener('click', handleCloseMenu);
        }
        const removeListeners = () => {
            setListerners(false);
            window.removeEventListener('scroll', fixMenuPosition);
            window.removeEventListener('click', handleCloseMenu);
        }

        if (menuOpen) {
            fixMenuPosition();
            startListeners();
        } else { removeListeners() }
        return () => { removeListeners() }

    }, [menuOpen])
    const handleOpenMenu = () => { setMenuOpen(true) }
    const handleCloseMenu = useCallback((e) => {
        const bypass = e.target.classList.contains(NavDivMobileBypassHandleCloseMenu);
        if (bypass) { return };
        setMenuOpen(false)
    }, [])

    return <>
        {/* <p ref={refBarTitle} className={`${styles.NavDivMobile} ${styles.Title}`} color='#333'></p> */}
        {!menuOpen && <IconMenu onClick={handleOpenMenu} className={`${styles.NavDivMobile} ${styles.ButtonMenu} ${NavDivMobileBypassHandleCloseMenu}`} color='#333' />}
        {menuOpen && <IconClose onClick={handleCloseMenu} className={`${styles.NavDivMobile} ${styles.ButtonMenu} `} color='#333' />}
        {menuOpen &&
            <section className={`${styles.NavDivMobile} ${styles.MobileMenu} `} ref={MobileMenuRef}>
                <DropdownCity allowHover={false} />
                {state && <LeftLinks className={styles.LeftLinks} refBarTitle={refBarTitle} />}
                <div className={styles.WelcomeLinks}>
                    <WelcomeLinks
                        isAuthenticated={isAuthenticated}
                        userId={userId}
                        AppDownloadModalRef={AppDownloadModalRef}
                    />
                </div>
            </section>
        }
        {/* Aqui é responável por extrair o texto do link selecionado e jogar pa o 'refBarTitle' */}
        {/* <LeftLinksGetSelected refBarTitle={refBarTitle} /> */}
    </>
}

